import type { StateCreator } from 'zustand';

import type {
  CommunicationReportActionsStore,
  CommunicationReportItemActionKind,
} from './types';
import { INITIAL_COMMUNICATION_REPORT_ACTIONS_STATE } from './types';

export const createCommunicationReportActionsSlice: StateCreator<
  CommunicationReportActionsStore
> = (set, get) => ({
  ...INITIAL_COMMUNICATION_REPORT_ACTIONS_STATE,

  markActionPending: (itemId: string) => {
    set((state) => ({
      pendingByItemId: { ...state.pendingByItemId, [itemId]: true },
    }));
  },

  markActionCompleted: (
    itemId: string,
    kind: CommunicationReportItemActionKind,
  ) => {
    set((state) => ({
      actionsByItemId: { ...state.actionsByItemId, [itemId]: kind },
      pendingByItemId: { ...state.pendingByItemId, [itemId]: false },
    }));
  },

  clearActionPending: (itemId: string) => {
    set((state) => ({
      pendingByItemId: { ...state.pendingByItemId, [itemId]: false },
    }));
  },

  resetItem: (itemId: string) => {
    set((state) => {
      const nextActions = { ...state.actionsByItemId };
      const nextPending = { ...state.pendingByItemId };
      delete nextActions[itemId];
      delete nextPending[itemId];
      return { actionsByItemId: nextActions, pendingByItemId: nextPending };
    });
  },

  resetState: () => set(INITIAL_COMMUNICATION_REPORT_ACTIONS_STATE),

  useActionFor: (itemId: string) => {
    return get().actionsByItemId[itemId];
  },

  useIsPendingFor: (itemId: string) => {
    return get().pendingByItemId[itemId] ?? false;
  },
});
